"use client";

import React from "react";
// import UpdatedHeader from "@/components/common/UpdatedHeader";
import QuickContact from "@/components/common/QuickContact";
import BannerDesktopHFM from "@/components/pageComponent/hire-from-miles/BannerDesktopHFM";
import HireFromMilesFooter from "@/components/pageComponent/hire-from-miles/HireFromMilesFooter";
import StatisticsDesktopHFM from "@/components/pageComponent/hire-from-miles/StatisticsDesktopHFM";
import LongTermNursingTalentHFM from "@/components/pageComponent/hire-from-miles/LongTermNursingTalentHFM";
import LeverageAccountingTalentPoolHFM from "@/components/pageComponent/hire-from-miles/LeverageAccountingTalentPoolHFM";
import BrandAndAdvertisingTopTalentHFM from "@/components/pageComponent/hire-from-miles/BrandAndAdvertisingTopTalentHFM";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";

export interface FormProps {
  submitButtonName: string;
  formTitle: string | false;
  showWebinar: boolean;
  popupName?: boolean;
  PopupId?: number;
  popupUserId?: null | number;
}

const DesktopPage: React.FC = () => {
  return (
    <main className="flex flex-col items-center bg-white min-h-screen w-full">
      <div className="bg-[#191919] w-full blue_shadow z-[99]">
        <GlobalHeaderNew />
      </div>
      <BannerDesktopHFM />
      <StatisticsDesktopHFM />
      <LeverageAccountingTalentPoolHFM />
      <LongTermNursingTalentHFM />
      <BrandAndAdvertisingTopTalentHFM />
      <HireFromMilesFooter />
      <QuickContact />
    </main>
  );
};

export default DesktopPage;
